import { washData_indexCase } from '@/components/widgets/index_case/washData.js'
import { washData as washDataHomeProductList } from '@/components/widgets/home_product_list/washData.js'
import { washData as washDataListDownloadWidget } from '@/components/widgets/list_download_widget/washData.js'
import { washData as washDataProductIntro } from '@/components/widgets/product_intro/washData.js'
import { washData_listNews } from '@/components/widgets/list_news/washData.js'
import { washData_productImgText } from '@/components/widgets/product_imgText/washData.js'
import { washData_productImgText1 } from '@/components/widgets/product_imgText_style1/washData.js'
import { washData_productImgText2 } from '@/components/widgets/product_imgText_style2/washData.js'
import { washData_productImgText3 } from '@/components/widgets/product_imgText_style3/washData.js'
import { washData_expandCollapseTags } from '@/components/widgets/expand_collapse_tags/washData.js'
import { washData_expandCollapseText } from '@/components/widgets/expand_collapse_text/washData.js'
import { washData_relatedCarouselProduct } from '@/components/widgets/related_carousel_product/washData.js'
import { washData as washDataHomeProductListFive } from '@/components/widgets/home_product_list_five/washData.js'
import { washData_relatedCarouselNews } from '@/components/widgets/related_carousel_news/washData.js'
import { washData_relatedCarouselCase } from '@/components/widgets/related_carousel_case/washData.js'
import { washData_relatedCarouselFaq } from '@/components/widgets/related_carousel_faq/washData.js'
import { washData_rowCol } from '@/components/widgets/rowCol/washData.js'
import { washData_bannerItem } from '@/components/widgets/banner_item/washData.js'
import { washData as washHead } from '@/components/widgets/head_one/washData.js'
import { washData_footModule } from '@/components/widgets/foot_module/washData.js'
import {washData_scrollText} from "@/components/widgets/text_scrollText/washData.js";
import {washData_textTitle} from "@/components/widgets/text_title/washData.js";
import {washData_textParagraph} from "@/components/widgets/text_paragraph/washData.js";

import {washData_buttonText} from "@/components/widgets/button_text/washData.js";
import {washData_buttonTextBorder} from "@/components/widgets/button_text_border/washData.js";
import {washData_buttonTextIcon} from "@/components/widgets/button_text_icon/washData.js";
import {washData_buttonTextIconNew} from "@/components/widgets/button_text_icon_new/washData.js";
import {washData_iconButton} from "@/components/widgets/icon_button/washData.js";
import {washData_image_image1} from "@/components/widgets/image_image1/washData.js";
import {washData_image_image2} from "@/components/widgets/image_image2/washData.js";
import {washData_col} from "@/components/widgets/col/washData.js";
import {washData_container} from "@/components/widgets/container/washData.js";

import { washData_nav } from '@/components/widgets/nav/washData.js'
import { washData as washCaseDetail } from '@/components/widgets/case_detail/washData.js'
import { washData as washNewsDetail } from '@/components/widgets/news_detail/washData.js'

import { washData as washCertList } from '@/components/widgets/list_cert_widget/washData.js'
import { washData as washProductClassification } from '@/components/widgets/product_classification/washData.js'
import { washData as washProductClassiStyle1 } from '@/components/widgets/product_classification_style1/washData.js'
import { washData as washNewsTabOne } from '@/components/widgets/news_tab_one/washData.js'
import { washData as washNewsTabTwo } from '@/components/widgets/news_tab_two/washData.js'
import { washData as washNewsTab } from '@/components/widgets/news_tab/washData.js'
import { washData as washListProduct } from '@/components/widgets/list_product/washData.js'
import { washData as washListNewsIndex } from '@/components/widgets/list_news_index/washData.js'
import { washData as washListCase } from '@/components/widgets/list_case/washData.js'
import { washData as washListDownload } from '@/components/widgets/list_download/washData.js'

import { washData as washData_productHomeListStyle3 } from '@/components/widgets/product_home_list/style3/washData.js'
import { washData as washData_productHomeListStyle2 } from '@/components/widgets/product_home_list/style2/washData.js'
import { washData as washData_productCategoryStyle3 } from '@/components/widgets/product_category/style3/washData.js'
import { washData as washData_relatedCarouselNewNews } from '@/components/widgets/related_carousel_new_news/style1/washData.js'
import { washData as washData_relatedCarouselNewNewsStyle2 } from '@/components/widgets/related_carousel_new_news/style2/washData.js'
import { washData as washData_relatedCarouselNewNewsStyle3 } from '@/components/widgets/related_carousel_new_news/style3/washData.js'
import { washData as washData_relatedCarouselNewNewsStyle4 } from '@/components/widgets/related_carousel_new_news/style4/washData.js'
import { washData as washData_relatedCarouselNewCaseStyle4 } from '@/components/widgets/related_carousel_new_case/style4/washData.js'
import { washData as washData_relatedCarouselNewCaseStyle3 } from '@/components/widgets/related_carousel_new_case/style3/washData.js'
import { washData as washData_productHomeListStyle5 } from '@/components/widgets/product_home_list/style5/washData.js'
import { washData as washData_productHomeListStyle6 } from '@/components/widgets/product_home_list/style6/washData.js'
import { washData as washProductTabTwo } from '@/components/widgets/product_tab_two/washData.js'
import { washData as washProductTabOne } from '@/components/widgets/product_tab_one/washData.js'
import { washData as washProductTabThree } from '@/components/widgets/product_tab_three/washData.js'
import { washData as washProductTabFour } from '@/components/widgets/product_tab_four/washData.js'
import { washData as washHomeVideoOne } from '@/components/widgets/home_video_list/washData.js'
import { washData as washHomeVideoTwo } from '@/components/widgets/home_video_list_two/washData.js'
import { washData as washVideoList } from '@/components/widgets/video_list/washData.js'
import { washData as washProductCateIntro } from '@/components/widgets/product_cate_intro/washData.js'
import { washData as washProductCateList } from '@/components/widgets/product_cate_list/washData.js'
import { washData as washProductTabFive } from '@/components/widgets/product_tab_five/washData.js'
import { washData as washProductTabSix } from '@/components/widgets/product_tab_six/washData.js'
import { washData as washCarouselCase } from '@/components/widgets/related_carousel_case_w/washData.js'
import { washData as washProduct11 } from '@/components/widgets/list_product/style11/washData.js'
import { washData as washdev2 } from '@/components/widgets/development_history/style2/washData.js'
import { washData as washData_category5 } from '@/components/widgets/product_category/style5/washData.js'
import { washData as washData_category6 } from '@/components/widgets/product_category/style6/washData.js'
import { washData as washData_category7 } from '@/components/widgets/product_category/style7/washData.js'
import { washData as washData_product13 } from '@/components/widgets/list_product/style13/washData.js'
import { washData as washData_news8 } from '@/components/widgets/list_news/style8/washData.js'
import { washData as washData_imgTextTab4 } from '@/components/widgets/image_text_tab/style4/washData.js'
import { washData as washData_advanced } from '@/components/widgets/advanced_controls/style1/washData.js'
import { washData as washData_product14 } from '@/components/widgets/list_product/style14/washData.js'
import {washData as washData_homeProduct1 } from '@/components/widgets/home_product_list_widget/style1/washData.js'

export function portOfWashDataAssembly(walkedNode) {
  if (walkedNode.componentName === 'list_news') {
    washData_listNews(walkedNode)
  } else if (walkedNode.componentName === 'list_news_style1') {
    washData_listNews(walkedNode)
  } else if (walkedNode.componentName === 'text_scrollText') {
    washData_scrollText(walkedNode)
  } else if (walkedNode.componentName === 'text_title') {
    washData_textTitle(walkedNode)

  }else if (walkedNode.componentName === 'text_paragraph') {
    washData_textParagraph(walkedNode)
  }
  else if (walkedNode.componentName === 'button_text') {
    washData_buttonText(walkedNode)
  }else if (walkedNode.componentName === 'button_text_border') {
    washData_buttonTextBorder(walkedNode)
  }else if (walkedNode.componentName === 'button_text_icon') {
    washData_buttonTextIcon(walkedNode)
  }else if (walkedNode.componentName === 'button_text_icon_new') {
    washData_buttonTextIconNew(walkedNode)
  }else if (walkedNode.componentName === 'icon_button') {
    washData_iconButton(walkedNode)
  }else if (walkedNode.componentName === 'image_image1') {
    washData_image_image1(walkedNode)
  }else if (walkedNode.componentName === 'image_image2') {
    washData_image_image2(walkedNode)
  }else if (walkedNode.componentName === 'col') {
    washData_col(walkedNode)
  }else if (walkedNode.componentName === 'container') {
    washData_container(walkedNode)
  }
  else if (walkedNode.componentName === 'index_case') {

  } else if (walkedNode.componentName === 'text_paragraph') {
    washData_textParagraph(walkedNode)
  } else if (walkedNode.componentName === 'index_case') {
    washData_indexCase(walkedNode)
  } else if (walkedNode.componentName === 'index_case_style2') {

    washData_indexCase(walkedNode)
  } else if (walkedNode.componentName === 'home_product_list') {
    washDataHomeProductList(walkedNode)
  } else if (walkedNode.componentName === 'list_download_widget') {
    washDataListDownloadWidget(walkedNode)
  } else if (walkedNode.componentName === 'product_intro') {
    washDataProductIntro(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText') {
    washData_productImgText(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText_style1') {
    washData_productImgText1(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText_style2') {
    washData_productImgText2(walkedNode)
  } else if (walkedNode.componentName === 'product_imgText_style3') {
    washData_productImgText3(walkedNode)
  } else if (walkedNode.componentName === 'expand_collapse_tags') {
    washData_expandCollapseTags(walkedNode)
  } else if (walkedNode.componentName === 'expand_collapse_text') {
    washData_expandCollapseText(walkedNode)
  } else if (
    walkedNode.componentName === 'related_carousel_product' ||
    walkedNode.componentName === 'related_carousel_product_style5' ||
    walkedNode.componentName === 'related_carousel_product_style7' ||
    walkedNode.componentName === 'related_carousel_product_style8'
  ) {
    washData_relatedCarouselProduct(walkedNode)
  } else if (walkedNode.componentName === 'home_product_list_five') {
    washDataHomeProductListFive(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_news') {
    washData_relatedCarouselNews(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_case') {
    washData_relatedCarouselCase(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_faq') {
    washData_relatedCarouselFaq(walkedNode)
  } else if (walkedNode.componentName === 'banner_item') {
    washData_bannerItem(walkedNode)
  } else if (walkedNode.componentName === 'head_one') {
    washHead(walkedNode)
  } else if (walkedNode.componentName === 'rowCol') {
    washData_rowCol(walkedNode)
  } else if (walkedNode.componentName === 'foot_module') {
    washData_footModule(walkedNode)
  } else if (
    ['case_detail_one', 'case_detail_two', 'case_detail'].includes(walkedNode.componentName)
  ) {
    washCaseDetail(walkedNode)
  } else if (
    ['news_detail_three', 'news_detail_two', 'news_detail_one'].includes(walkedNode.componentName)
  ) {
    washNewsDetail(walkedNode)
  } else if (walkedNode.componentName === 'nav') {
    washData_nav(walkedNode)
  } else  if (walkedNode.componentName === 'list_cert_widget') {

  } else if (walkedNode.componentName === 'list_product') {
    washListProduct(walkedNode)
  } else if (walkedNode.componentName === 'list_news_index') {
    washListNewsIndex(walkedNode)
  } else if (walkedNode.componentName === 'list_case') {
    washListCase(walkedNode)
  } else if (walkedNode.componentName === 'list_download') {
    washListDownload(walkedNode)
  } else if (walkedNode.componentName === 'list_cert_widget') {
    washCertList(walkedNode)
  } else if (walkedNode.componentName === 'product_classification') {
    washProductClassification(walkedNode)
  } else if (walkedNode.componentName === 'product_classification_style1') {
    washProductClassiStyle1(walkedNode)
  } else if (walkedNode.componentName === 'news_tab_one') {
    washNewsTabOne(walkedNode)
  } else if (walkedNode.componentName === 'news_tab_two') {
    washNewsTabTwo(walkedNode)
  } else if (walkedNode.componentName === 'news_tab' && walkedNode._type === 'news_tab_3') {
    washNewsTab(walkedNode)
  } else if (walkedNode.componentName === 'list_product') {
    washListProduct(walkedNode)
  } else if (walkedNode.componentName === 'list_news_index') {
    washListNewsIndex(walkedNode)
  } else if (walkedNode.componentName === 'list_case') {
    washListCase(walkedNode)
  } else if (walkedNode.componentName === 'list_download') {
    washListDownload(walkedNode)
  } else if (walkedNode.componentName === 'list_product' && walkedNode._type === 'list_product_style11') {
    washProduct11(walkedNode)
  } else if (walkedNode.componentName === 'product_home_list') {
    washData_productHomeListStyle3(walkedNode)
  } else if (walkedNode.componentName === 'product_home_list_style2') {
    washData_productHomeListStyle2(walkedNode)
  } else if (walkedNode.componentName === 'product_category_style3') {
    washData_productCategoryStyle3(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_new_news_style1') {
    washData_relatedCarouselNewNews(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_new_news_style2') {
    washData_relatedCarouselNewNewsStyle2(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_new_news_style3') {
    washData_relatedCarouselNewNewsStyle3(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_new_news_style4') {
    washData_relatedCarouselNewNewsStyle4(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_new_case_style4') {
    washData_relatedCarouselNewCaseStyle4(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_new_case_style3') {
    washData_relatedCarouselNewCaseStyle3(walkedNode)
  } else if (walkedNode.componentName === 'product_home_list_style5') {
    washData_productHomeListStyle5(walkedNode)
  } else if (walkedNode.componentName === 'product_home_list_style6') {
    washData_productHomeListStyle6(walkedNode)
  } else if (walkedNode.componentName === 'product_tab_1') {
    washProductTabOne(walkedNode)
  } else if (walkedNode.componentName === 'product_tab_2') {
    washProductTabTwo(walkedNode)
  } else if (walkedNode.componentName === 'product_tab_3') {
    washProductTabThree(walkedNode)
  } else if (walkedNode.componentName === 'product_tab_4') {
    washProductTabFour(walkedNode)
  } else if (
    walkedNode.componentName === 'home_video_one' ||
    walkedNode.componentName === 'home_video_three'
  ) {
    washHomeVideoOne(walkedNode)
  } else if (walkedNode.componentName === 'home_video_two') {
    washHomeVideoTwo(walkedNode)
  } else if (
    walkedNode.componentName === 'video_list' ||
    walkedNode.componentName === 'video_list_two'
  ) {
    washVideoList(walkedNode)
  } else if (walkedNode.componentName === 'product_cate_intro') {
    washProductCateIntro(walkedNode)
  } else if (walkedNode.componentName === 'product_cate_list') {
    washProductCateList(walkedNode)
  } else if (walkedNode.componentName === 'product_tab_five') {
    washProductTabFive(walkedNode)
  } else if (walkedNode.componentName === 'product_tab_six') {
    washProductTabSix(walkedNode)
  } else if (walkedNode.componentName === 'related_carousel_case_w') {
    washCarouselCase(walkedNode)
  } else if (walkedNode._type === 'list_product_style11') {
    washProduct11(walkedNode)
  } else if (walkedNode.componentName === 'development_history_2') {
    washdev2(walkedNode)
  } else if (
    walkedNode.componentName === 'list_product' &&
    walkedNode._type === 'list_product_style11'
  ) {
    washProduct11(walkedNode)
  } else if (walkedNode.componentName === 'product_category_style5') {
    washData_category5(walkedNode)
  } else if (walkedNode.componentName === 'product_category_style6') {
    washData_category6(walkedNode)
  } else if (walkedNode.componentName === 'product_category_style7') {
    washData_category7(walkedNode)
  } else if (walkedNode._type === 'list_product_style13') {
    washData_product13(walkedNode)
  } else if (walkedNode.componentName === 'list_news_style8') {
    washData_news8(walkedNode)
  } else if (walkedNode.componentName === 'image_text_tab_style4') {
    washData_imgTextTab4(walkedNode)
  } else if (walkedNode.componentName === 'high_components_style1') {
    washData_advanced(walkedNode)
  } else if (walkedNode._type === 'list_product_style14') {
    washData_product14(walkedNode)
  } else if (walkedNode.componentName === 'home_product_list_style1') {
    washData_homeProduct1(walkedNode)
  }
}
